import { gsap } from 'gsap/gsap-core';
import { lenis } from '../animations/scroll';

export function init(): void {
    const container = document.querySelector('.accordion-container');
    if (!container) return;

    const items = container.querySelectorAll<HTMLElement>('.accordion');

    const hasActive = Array.from(items).some((item) => item.classList.contains('is-active'));
    if (!hasActive && items.length > 0) {
        items[0].classList.add('is-active');
    }

    items.forEach((item) => {
        const header = item.querySelector<HTMLElement>('.accordion-header');
        const content = item.querySelector<HTMLElement>('.accordion-content');
        if (!header || !content) return;

        // Synchroniser GSAP avec l'état initial
        if (!item.classList.contains('is-active')) {
            gsap.set(content, { height: 0 });
        }

        header.addEventListener('click', () => {
            const isOpen = item.classList.contains('is-active');

            items.forEach((other) => {
                if (other !== item && other.classList.contains('is-active')) {
                    other.classList.remove('is-active');
                    const otherContent = other.querySelector<HTMLElement>('.accordion-content');
                    if (otherContent) {
                        gsap.to(otherContent, {
                            height: 0,
                            duration: 0.4,
                            ease: 'power2.inOut',
                            onComplete: () => lenis?.resize(),
                        });
                    }
                }
            });

            if (!isOpen) {
                item.classList.add('is-active');
                gsap.to(content, {
                    height: 'auto',
                    duration: 0.4,
                    ease: 'power2.inOut',
                    onComplete: () => lenis?.resize(),
                });
            } else {
                item.classList.remove('is-active');
                gsap.to(content, {
                    height: 0,
                    duration: 0.4,
                    ease: 'power2.inOut',
                    onComplete: () => lenis?.resize(),
                });
            }
        });
    });
}
